/**
 * Limpa dados persistidos do modo demo e recarrega a página para restaurar
 * estado inicial (badges de notificação, notas editadas, ocorrências, etc.).
 *
 * As "pré-configurações" do roteiro demo (auto-abertura do sino em aula ao vivo,
 * ciência obrigatória no refresh, etc.) estão centralizadas em `demoScenario.js`.
 * Este módulo cuida apenas da **limpeza dos flags de sessão** que o roteiro usa
 * para lembrar o que o professor já interagiu, permitindo simular tudo de novo.
 */

const DEMO_LOCAL_STORAGE_KEYS = [
  "waybee-class-diary-demo-occurrences-v1",
  "waybee-class-diary-demo-grades-v1",
  "waybee-class-diary-demo-grades-v2"
];

/** Ciência obrigatória (modal) — limpo no reset da demo para voltar a exibir o aviso. */
export const DEMO_ACK_SESSION_KEY = "demoClassDiaryAckDismissed";

const DEMO_SESSION_STORAGE_KEYS = [
  DEMO_ACK_SESSION_KEY,
  "waybee-demo-schedule-slot-status"
];

export function clearDemoPersistedStorage() {
  if (typeof localStorage === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  DEMO_LOCAL_STORAGE_KEYS.forEach(k => localStorage.removeItem(k));
  DEMO_SESSION_STORAGE_KEYS.forEach(k => sessionStorage.removeItem(k));
}

export function resetDemoAndReload() {
  clearDemoPersistedStorage();
  if (typeof window !== "undefined") {
    window.location.reload();
  }
}
